const MuiAvatarOverrides = {
  MuiAvatar: {
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          fontSize: theme.typography.body01.fontSize,
          fontWeight: 'normal'
        };
      },
      square: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          color: theme.palette.gray80,
          fontWeight: 'bold'
        };
      }
    }
  }
};

export { MuiAvatarOverrides };
